export default class StringUtils {
  /**
   * Format string by replacing placeholders with value from element with
   * corresponding index in `replacementArray`.
   * Replaces are made simultaneously, so that replacement values like
   * '{1}' will not mess up the function.
   *
   * Example 1:
   * ('{2} {1} {0}', ['three', 'two' ,'one']) -> 'one two three'
   *
   * Example 2:
   * ('{0}{1}', ['{1}', '{0}']) -> '{1}{0}'
   */
  static stringFormat(formatString: string, replacementArray: any[]): string {
    return formatString.replace(
      /\{(\d+)\}/g, // Matches placeholders, e.g. '{1}'
      function formatStringReplacer(match, placeholderIndex) {
        // Convert String to Number
        placeholderIndex = Number(placeholderIndex);

        // Make sure that index is within replacement array bounds
        if (
          placeholderIndex < 0 ||
          placeholderIndex > replacementArray.length - 1
        ) {
          return placeholderIndex;
        }

        // Replace placeholder with value from replacement array
        return replacementArray[placeholderIndex];
      },
    );
  }

  static stripTags(
    html: string | null | undefined,
    truncate = false,
    truncateLength = 120,
  ): string | null {
    if (!html) return null;

    let strippedString = html.replace(/(<([^>]+)>)/gi, '');

    if (truncate && strippedString.length > truncateLength) {
      strippedString = strippedString.substring(0, truncateLength);
      strippedString += '...';
    }
    return strippedString;
  }
}
